
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-1e018e6d&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LoanDetails.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LoanDetails.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-1e018e6d!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LoanDetails.vue"),
  /* scopeId */
  "data-v-1e018e6d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/Loan/LoanDetails.vue
// module id = 720
// module chunks = 0